import { useEffect, useState } from "react";
import { _LoanLine } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { _RequestCredit, _single, _SystemPropertyOB } from "../../../../../core/services/dataBean/EntityCatalog";
import { MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import "./CC002.css"
import { TabPills } from "./Components/TabPills";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC002 = ({ configProcedure }: Props) => {
    const { instance, setBean, bean, lista, setLista } = useDataBean(_LoanLine);
    const propertie = useDataBean(_SystemPropertyOB)

    const request = useDataBean(_RequestCredit);
    const [loan, setLoan] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [useValue, setUseValue] = useState<number>(0);

    useEffect(() => {
        setProps(configProcedure._pocessData.Props);
        getReuqest();
        getProperty()
    }, [configProcedure]);

    const getProperty = () => {
        propertie.instance.getSystemProperty("time_session").then(
            (resp) => {
                setUseValue(resp.SystemValue)
            }
        ).catch(err => { console.log(err) })
    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        request.instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                request.setBean(resp[0].DataBeanProperties)
                console.log(resp[0].DataBeanProperties)
            }
        ).catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        if (props?.IDLoanLine && props.IDLoanLine > 0) {
            instance.getLoanLine(props.IDLoanLine).then((data: any) => {
                setLoan(data);
            });
        }
        setStops([props?.MinimumLoanAmount, props?.MaximumLoanAmount])
        setJump(props?.QuotaScale ?? 100000)

        if (props?.QuotaRange) {
            const arr = props.QuotaRange.split(',');
            const _arr = arr.map((e) => ({
                label: parseInt(e),
                valor: parseInt(e),
            }));
            setBean({ ...bean, CreditQuotes: _arr[0].valor, CreditValue: props?.MinimumLoanAmount  });
            setFeesArray(_arr);
        } else {
            const fallback = [{ label: 3, valor: 3 }];
            setBean({ ...bean, CreditQuotes: fallback[0].valor, CreditValue: props?.MinimumLoanAmount  });
            setFeesArray(fallback);
        }

    }, [props]);

    const validateForm = () => {
        const { CreditValue, CreditQuotes } = bean;
        const {
            MinQuotas = 1,
            MaxQuotas = Number.MAX_SAFE_INTEGER
        } = props || {}; // Evita error si props es undefined

        if (!CreditValue || !CreditQuotes) {
            toast.error("Debe ingresar el CreditValue y las CreditQuotes.");
            setBean({ ...bean, CreditValue: null, CreditQuotes: null });
            return false;
        }

        if (CreditQuotes < MinQuotas || CreditQuotes > MaxQuotas) {
            toast.error(`Las CreditQuotes deben estar entre ${MinQuotas} y ${MaxQuotas}`);
            setBean({ ...bean, CreditQuotes: null });
            return false;
        }

        return true;
    };



    const solicitar = () => {
        if (!validateForm()) return;

        const data = {
            CreditoValor: parseFloat(bean.CreditValue),
            CreditoCuotas: parseInt(bean.CreditQuotes),
            UseCodeudor: bean.CreditValue >= useValue,
        };

        console.log(data)

        updateCredit({ ...request.bean, JSONCredit: JSON.stringify({ ...bean, ...props }), AmountCredit: data.CreditoValor, Cuotes: data.CreditoCuotas, AmountTax: props.CurrentPercentInterest, StateRequest: 1 })
        configProcedure._exportMap(data);
        configProcedure._pushProps(data);
        configProcedure._pushInfo(`Se solicita un Credito de ${bean.CreditValue} pesos, a un plazo de ${bean.CreditQuotes} CreditQuotes`)
    };

    const updateCredit = (value) => {
        request.instance.updateRequestCredit(value).then(
            (resp) => {
                request.setBean(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const [stops, setStops] = useState([200000, 5000000])
    const [jump, setJump] = useState(100000)
    const [feesArray, setFeesArray] = useState([{ label: 3, valor: 3 }]);


    return (
        <div className="row">
            <div className="col-md-12">
                {/* <PrintJson json={props} /> */}
                <div className="row">
                    <div className="col-md-12">
                        <strong>Linea:</strong> {loan.Name} <br />
                    </div>
                    <div className="col-md-4 d-flex">
                        <strong>Minimo a solicitar :</strong>
                        <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props?.MinimumLoanAmount, MASK_MONEY) }}></div>
                    </div>
                    <div className="col-md-4 d-flex">
                        <strong>Maximo a solicitar :</strong>
                        <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props?.MaximumLoanAmount, MASK_MONEY) }}></div>
                    </div>
                    <hr />
                </div>
                <div className="row">
                    <div className="col-12 my-3 d-flex flex-column align-items-center">
                        <strong className='fw-semibold'>
                            <span className='titulres mx-3 fs-5 fst-italic'>Valor a financiar</span>
                            <span className="mx-2 fs-3 text-success" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.CreditValue, MASK_MONEY) }}>
                            </span>
                        </strong>
                    </div>

                    <div className="mt-3 d-flex flex-column align-items-center justify-content-center gap-2">
                        <small className='mx-auto p-0'>¿Cuál es tu plazo? <span className='text-muted'>(Meses)</span></small>
                        <div>
                            <TabPills lista={feesArray} onSelect={(e) => { setBean({ ...bean, CreditQuotes: e }) }} />
                        </div>
                    </div>

                    <div className="col-12 mt-2">
                        <div className="mb-3">
                            <small className="text-muted animate__animated animate__fadeIn">
                                <small>Desliza aquí para cambiar el valor</small>
                            </small>
                        </div>
                        <input className="rs-range" type="range" value={bean.CreditValue} min={stops[0]} max={stops[1]} step={jump}
                            onChange={(e) => setBean({ ...bean, CreditValue: parseInt(e.target.value) })}
                        />
                        <div className="d-flex justify-content-between">
                            <span className='mt-3' dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[0], MASK_MONEY) }} />
                            <span className='mt-3' dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[1], MASK_MONEY) }} />
                        </div>
                    </div>
                    <div className="col-md-4 mt-4">
                        <BasicButton disable={!bean.CreditValue || !bean.CreditQuotes} icon="" eventClick={solicitar}>Solicitar</BasicButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
